// FE-SCRM-048 — Two-card chooser surfaced both on the standalone
// /dashboard/sales-crm/import landing and embedded in the Settings →
// Import data section. Clicking a card deep-links into the wizard
// with the ``?type=<...>`` query param set.

import { Link } from "react-router-dom";

import { Card } from "@/design-system";


export interface ImportChooserCardsProps {
  /** Override the base path. Defaults to the standalone import route. */
  basePath?: string;
}


const CARDS = [
  {
    type: "prospects" as const,
    title: "Import prospects",
    description:
      "Your book of business: company names, renewal months, "
      + "current brokers, contacts coming separately.",
  },
  {
    type: "sales_contacts" as const,
    title: "Import contacts",
    description:
      "Sales contacts at prospects you've already imported.",
  },
];


export function ImportChooserCards({
  basePath = "/dashboard/sales-crm/import",
}: ImportChooserCardsProps) {
  return (
    <div
      data-testid="import-chooser-cards"
      className="grid gap-3 md:grid-cols-2"
    >
      {CARDS.map((c) => (
        <Card
          key={c.type}
          data-testid={`import-chooser-${c.type}`}
          className="p-0"
        >
          <Link
            to={`${basePath}?type=${c.type}`}
            className={[
              "block h-full rounded-md p-4",
              "hover:bg-recessed focus-visible:shadow-focus",
              "transition-colors",
            ].join(" ")}
          >
            <h3 className="text-sm font-semibold text-text-primary">
              {c.title}
            </h3>
            <p className="mt-1 text-xs text-text-secondary">
              {c.description}
            </p>
          </Link>
        </Card>
      ))}
    </div>
  );
}
